export default "__VITE_ASSET__52e90cb7__"